import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box,CircularProgress,Alert } from '@mui/material';
import { collection, getDocs,query,where,orderBy } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust the path as needed

const CategoryTabs = ({ selectedCategory, onSelectCategory,shopId }) => {
  const [categories, setCategories] = useState([]);
  const [loading,setLoading]=useState(true);
  const [error,setError]=useState('');

  useEffect(() => {
    const fetchCategories = async () => {
      try{
        const q = query(collection(db, 'categories'), where('shopId', '==', shopId),orderBy('name','asc'));
        const querySnapshot = await getDocs(q);
        const categoryList = querySnapshot.docs.map(doc => doc.data().name);
        setCategories(categoryList);
        setLoading(false);

        // Automatically select the first category if none is selected
        if (categoryList.length > 0 && !selectedCategory) {
          onSelectCategory(categoryList[0]);
        }
      }
      catch(error){
        setError(error);
        setLoading(false);
      }
     
    };
    fetchCategories();
  }, [shopId]);

  const handleChange = (event, newValue) => {
    onSelectCategory(categories[newValue]);
  };

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs
        value={categories.indexOf(selectedCategory)}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {categories.map((category, index) => (
          <Tab label={category} key={index} />
        ))}
      </Tabs>
    </Box>
  );
};

export default CategoryTabs;
